import type { OnboardingVariant } from "./onboarding";

export const ROUTES = {
  HOME: "/",
  MAGIC_LINK: "/magic-link",
  LOGIN: "/login",
  SIGNUP: "/signup",
  CREATE: "/create",
  VIDEOS: "/videos",
  AVATARS: "/avatars",
  PRIVACY: "/privacy-policy",
  TERMS: "/terms-of-service",
  PAYWALL: (paywallId: string) => `/paywall/${paywallId}`,
  ONBOARDING: (variant: OnboardingVariant | ":variant") => `/onboarding/${variant}`,
  PROFILE: "/profile",
  QUIZ: (quizId: string) => `/quiz/${quizId}`,
  PROFILE_SETTINGS: "/profile/settings",
  PROFILE_SUBSCRIPTION: "/profile/settings/subscription",
} as const;
